import { render, staticRenderFns } from "./GridVx.vue?vue&type=template&id=4ef6f2f3"
import script from "./GridVx.vue?vue&type=script&lang=js"
export * from "./GridVx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports